/* Recently Viewed — keep title+price visible on hover; second image swap; swipe/drag row (no arrows) */
(function () {
  const KEY = 'recently_viewed_handles_v1';
  const mount = document.getElementById('RecentlyViewed');
  if (!mount) return;

  const limit = parseInt(mount.dataset.limit || '8', 10);
  const inEditor = !!(window.Shopify && Shopify.designMode);
  const mqTablet = window.matchMedia('(min-width: 750px)');
  const mqDesktop = window.matchMedia('(min-width: 990px)');

  /* ---------- CSS (scoped) ---------- */
  (function injectCSS(){
    // Remove any previous rv-css so old rules (that hid title/price) don't stick
    const old = document.getElementById('rv-css');
    if (old) old.remove();

    const css = `
      .rv-wrap{position:relative;width:100%}
      .rv-viewport{overflow:auto;width:100%;scrollbar-width:auto}
      .rv-track{
        display:flex; gap:var(--gap,1.6rem); width:max-content;
        scroll-behavior:smooth; scroll-snap-type:x mandatory; -webkit-overflow-scrolling:touch;
        cursor:grab;
      }
      .rv-track.is-dragging{cursor:grabbing}
      .rv-item{
        flex:0 0 calc((var(--cw,100%) - (var(--cols,2) - 1)*var(--gap,1.6rem)) / var(--cols,2));
        max-width:calc((var(--cw,100%) - (var(--cols,2) - 1)*var(--gap,1.6rem)) / var(--cols,2));
        scroll-snap-align:start;
      }

      /* Hover: fade in 2nd image (Dawn-style) */
      .rv-card .media--hover-effect img + img{opacity:0;transition:opacity .25s ease}
      .rv-card:hover .media--hover-effect img + img{opacity:1}

      /* FORCE title + price visible on hover (in case older CSS hid them) */
      .rv-card .card__content{position:relative}
      .rv-card .card__information{visibility:visible; opacity:1}
      .rv-card:hover .card__information{visibility:visible !important; opacity:1 !important}

      /* Keep Dawn typography */
      .rv-card .card__heading.h5{line-height:1.3}
      .rv-card .price .price-item{font:inherit}
    `.trim();

    const tag = document.createElement('style');
    tag.id = 'rv-css';
    tag.textContent = css;
    document.head.appendChild(tag);
  })();

  /* ---------- storage ---------- */
  const urlHandle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  const onProduct =
    (window.meta && window.meta.product && window.meta.product.handle) ||
    (window.__st && window.__st.p === 'product' && window.__st.h) ||
    urlHandle || null;

  const get = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
  const set = (arr) => localStorage.setItem(KEY, JSON.stringify(arr.slice(0, 30)));

  if (onProduct) {
    const cur = get().filter(h => h && h !== onProduct);
    cur.unshift(onProduct);
    set(cur);
  }

  /* ---------- money + fetch ---------- */
  const shopCurrency =
    (window.Shopify && Shopify.currency && (Shopify.currency.shopCurrency || Shopify.currency.active)) ||
    document.documentElement.getAttribute('data-shopify-currency') || 'USD';

  const money = (cents) => {
    if (typeof cents !== 'number') return '';
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    return (cents/100).toLocaleString(undefined, { style:'currency', currency: shopCurrency });
  };

  const fetchProduct = (h) =>
    fetch(`/products/${encodeURIComponent(h)}.js`, { credentials:'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .catch(() => null);

  /* ---------- helpers ---------- */
  const esc = (s) => (s||'').replace(/[&<>"]/g, c=>({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]));
  const imgSrc = (p) => {
    const f = p.featured_image || (p.images && p.images[0]);
    return typeof f === 'string' ? f : (f && f.src) || '';
  };
  const secondImgSrc = (p) => {
    if (p.images && p.images.length > 1) {
      const s = p.images[1];
      return typeof s === 'string' ? s : (s && s.src) || '';
    }
    return '';
  };
  const srcset = (base) => base ? [165,360,533,720,940,1066].map(w => `${base}${base.includes('?')?'&':'?'}width=${w} ${w}w`).join(', ') : '';
  const getGridGapPx = () => {
    const grid = document.querySelector('.grid');
    if (grid) {
      const s = getComputedStyle(grid);
      const g = parseFloat(s.gap || s['column-gap']);
      if (!isNaN(g) && g > 0) return g;
    }
    if (mqDesktop.matches) return 20;
    if (mqTablet.matches)  return 18;
    return 16;
  };
  const getCols = () => (mqDesktop.matches ? 4 : mqTablet.matches ? 3 : 2);

  /* ---------- card ---------- */
  const toCard = (p) => {
    if (!p) return '';
    const v = (p.variants && p.variants.find(x=>x.available)) || (p.variants && p.variants[0]) || null;
    const priceC = v && v.price!=null ? parseInt(v.price,10) : (typeof p.price==='number' ? p.price : null);
    const compareC = v && v.compare_at_price ? parseInt(v.compare_at_price,10)
                   : (typeof p.compare_at_price==='number' ? p.compare_at_price : null);
    const onSale = compareC && priceC && compareC > priceC;
    const soldOut = !(v && v.available);
    const img1 = imgSrc(p);
    const img2 = secondImgSrc(p);
    const ratio = 133;

    return `
      <div class="card-wrapper product-card-wrapper underline-links-hover rv-card">
        <div class="card card--standard card--media" style="--ratio-percent:${ratio}%;">
          <div class="card__inner ratio" style="--ratio-percent:${ratio}%;">
            ${img1 ? `
            <div class="card__media">
              <a class="full-unstyled-link" href="/products/${p.handle}" aria-label="${esc(p.title)}">
                <div class="media media--transparent media--hover-effect">
                  <img
                    srcset="${srcset(img1)}"
                    src="${img1}${img1.includes('?')?'&':'?'}width=533"
                    sizes="(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                    alt="${esc(p.title)}" loading="lazy" class="motion-reduce">
                  ${img2 ? `
                  <img
                    srcset="${srcset(img2)}"
                    src="${img2}${img2.includes('?')?'&':'?'}width=533"
                    sizes="(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                    alt="${esc(p.title)}" loading="lazy" class="motion-reduce">` : ``}
                </div>
              </a>
            </div>` : ``}
          </div>

          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading h5">
                <a href="/products/${p.handle}" class="full-unstyled-link">${esc(p.title)}</a>
              </h3>
              <div class="card-information">
                <div class="price ${onSale ? 'price--on-sale' : ''}">
                  <div class="price__container">
                    ${!onSale && priceC!=null ? `
                      <div class="price__regular">
                        <span class="price-item price-item--regular">${money(priceC)}</span>
                      </div>` : ''}
                    ${onSale ? `
                      <div class="price__sale">
                        <span class="price-item price-item--sale price-item--last">${money(priceC)}</span>
                        <span class="price-item price-item--regular price-item--compare">${money(compareC)}</span>
                      </div>` : ''}
                  </div>
                </div>
              </div>
            </div>
            <!-- no size pills -->
            <div class="card__badge">
              ${soldOut ? `<span class="badge badge--bottom-left">Sold out</span>` : (onSale ? `<span class="badge badge--bottom-left">Sale</span>` : '')}
            </div>
          </div>
        </div>
      </div>`;
  };

  /* ---------- build ---------- */
  async function render() {
    const handles = get().filter(Boolean).filter(h => h !== onProduct).slice(0, limit);
    if (!handles.length) {
      if (!inEditor) { const sec = mount.closest('section'); if (sec) sec.style.display = 'none'; }
      else mount.innerHTML = '';
      return;
    }

    const products = await Promise.all(handles.map(fetchProduct));
    const itemsHTML = products.filter(Boolean).map(p => `<div class="rv-item">${toCard(p)}</div>`).join('');
    if (!itemsHTML) { mount.innerHTML = ''; return; }

    mount.innerHTML = `
      <div class="rv-wrap">
        <div class="rv-viewport"><div class="rv-track">${itemsHTML}</div></div>
      </div>`;

    const wrap  = mount.querySelector('.rv-wrap');
    const viewport = mount.querySelector('.rv-viewport');
    const track = mount.querySelector('.rv-track');

    function setDimensions() {
      const container = mount.closest('.page-width, .section, section') || mount.parentElement;
      const cw = container ? container.clientWidth : mount.clientWidth;
      wrap.style.setProperty('--cw', cw + 'px');
      const gap = getGridGapPx();
      wrap.style.setProperty('--gap', gap + 'px');
      wrap.style.setProperty('--cols', (mqDesktop.matches ? 4 : mqTablet.matches ? 3 : 2));
      track.style.gap = gap + 'px';
    }

    // Desktop: vertical wheel -> horizontal scroll
    viewport.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        viewport.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });

    // Drag-to-scroll (desktop)
    let isDown = false, startX = 0, startLeft = 0;
    track.addEventListener('mousedown', (e) => {
      isDown = true; track.classList.add('is-dragging');
      startX = e.clientX; startLeft = viewport.scrollLeft; e.preventDefault();
    });
    window.addEventListener('mouseup', () => { isDown = false; track.classList.remove('is-dragging'); });
    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      viewport.scrollLeft = startLeft - (e.clientX - startX);
    });

    window.addEventListener('resize', setDimensions);
    mqTablet.addEventListener?.('change', setDimensions);
    mqDesktop.addEventListener?.('change', setDimensions);

    setDimensions();
    const ro = new ResizeObserver(setDimensions);
    ro.observe(mount.closest('.page-width, .section, section') || mount);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', render) : render();
  if (inEditor) {
    document.addEventListener('shopify:section:load', render);
    document.addEventListener('shopify:section:reorder', render);
  }
})();